import Component from "./component";

class Mass extends Component {
  static Small = 0;
  static Medium = 1;
  static Large = 2;

  constructor(_size) {
    super();
    this.size = _size;
  }
}

export default Mass;
